import { usePartner } from "@src/partner"
import React from "react"
import { Button, Card, Col, OverlayTrigger, Tooltip } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { StyleSheet } from "@src/types"
import { InfoCircle } from "react-bootstrap-icons"

type StatisticCardProps = {
  show: boolean
  title: string
  loading: boolean
  isDetailed?: boolean
  isDeviceActive?: boolean
  totalCount?: any
  isRadial?: boolean
  isColumnDetail?: boolean
  totalRadialValue?: string
  radialValue?: string
  tooltip: string
  titles?: string[]
  detailCounts?: any[]
  onButtonClick?: () => void
}

const pageClassName = "shadow-2 rounded mt-2 mb-2"
export const alignCenterBetween = "d-flex flex-column align-items-center"

const formatTotalCount = (value: any): string => {
  if (value === null || value === undefined || value === "") return value

  const numValue = Number(value)
  if (isNaN(numValue)) return value

  if (Number.isInteger(numValue)) return numValue.toString()

  return numValue.toFixed(2)
}

export const StatisticCard: React.FC<StatisticCardProps> = ({
  show,
  title,
  totalCount,
  tooltip,
  onButtonClick,
}) => {
  const { brand } = usePartner()
  const { t } = useTranslation()
  const styles: StyleSheet = {
    borderStyles: {
      flex: 1,
      borderWidth: 1,
      borderColor: "#dee2e6",
      borderRadius: "30px",
      height: "inherit",
      maxWidth: "220px",
      minWidth: "170px",
      minHeight: "150px",
    },
    cardTitle: {
      color: "#636E72",
      fontSize: "17px",
      marginTop: "2.5px",
      minHeight: "50px",
    },
    cardValue: {
      color: brand?.color,
    },
    detail: {
      flex: 1,
      flexDirection: "column",
      marginTop: "10px",
      marginRight: "10px",
      padding: "10px",
      backgroundColor: "#F0F0F0",
      justifyContent: "space-between",
      borderRadius: "10px",
    },
    divider: {
      height: "70px",
      backgroundColor: "green",
      width: 2,
    },
    horizontalDivider: {
      backgroundColor: "#F0F0F0",
      width: "100%",
      height: 2,
    },
  }

  const Link = ({ id, children }) => (
    <OverlayTrigger overlay={<Tooltip id={id}>{tooltip || "No tooltip available"}</Tooltip>}>
      <a href="#" className="ms-1 me-1">
        {children}
      </a>
    </OverlayTrigger>
  )

  if (show) {
    return (
      <Col style={{ display: "flex" }}>
        <Card className={pageClassName} style={styles.borderStyles}>
          <Card.Body>
            <div className="d-flex flex-column">
              <div className="d-flex flex-row">
                <Card.Title style={styles.cardTitle}>{title}</Card.Title>
                <Link id="info">
                  <InfoCircle color="#636E72" size={15} />
                </Link>
              </div>
              {totalCount && (
                <div className="align-self-start me-3">
                  <div className="fs-1" style={styles.cardValue}>
                    {formatTotalCount(totalCount)}
                  </div>
                </div>
              )}
              {onButtonClick && (
                <div className="mt-2">
                  <Button variant="link" className="p-0" onClick={onButtonClick}>
                    {t("devices_screen.show_more")}
                  </Button>
                </div>
              )}
            </div>
          </Card.Body>
        </Card>
      </Col>
    )
  }
}
